import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

import { Provider, getServerData, getTemplate } from "@reactivated";

import "./styles/global.scss";

async function init() {
    const { props, context } = getServerData();

    if (context.SENTRY_DSN) {
        Sentry.init({
            dsn: context.SENTRY_DSN,
            release: context.CI_COMMIT_SHA,
            environment: context.CI_COMMIT_REF_SLUG,
            integrations: [],
            beforeSend(event) {
                // Drop errors injected by browser/Safari extensions. Safari
                // masks the URLs of extension-injected scripts as
                // "webkit-masked-url://", so any frame from one is not our code.
                const frames =
                    event.exception?.values?.flatMap(
                        (value) => value.stacktrace?.frames ?? [],
                    ) ?? [];
                if (
                    frames.some((frame) =>
                        frame.filename?.startsWith("webkit-masked-url://"),
                    )
                ) {
                    return null;
                }
                return event;
            },
        });
    }

    const Template = await getTemplate(context);

    ReactDOM.hydrateRoot(
        document,
        <React.StrictMode>
            <Provider value={context}>
                <Template {...props} />
            </Provider>
        </React.StrictMode>,
    );
}
void init();
